// Generated types for ToolCallPart
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ResponsePartReadAPI, ResponsePartWriteAPI } from './responsepart';
import { ResponsePartReadAPISchemaObject, ResponsePartWriteAPISchemaObject } from './responsepart';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ToolCallPartReadAPI extends ResponsePartReadAPI {
  /** Name of the tool being called */
  tool_name: string;
  /** Provider-issued identifier for this tool call. NOT globally unique — Gemini reuses short ids (call_NNNNN) across a long thread and across chats. Resolve via `resolve_by_call_id`, never a bare global filter. */
  tool_call_id: string;
  /** Arguments passed to the tool (an object; stored as JSON text) */
  args?: Record<string, unknown>;
  /** Whether this tool call is being streamed */
  is_streaming?: boolean;
  /** Provider that produced this part (required when provider_details carries a signature). */
  provider_name?: string | null;
  /** Opaque provider metadata (e.g. Gemini thought_signature on function_call parts). */
  provider_details?: Record<string, unknown> | null;
  /** Set by tools that defer for approval after running a preview pass (e.g. delete tools' dry-run cascade). The frontend reads this to render the cascade scope alongside the Approve / Deny prompt. Cleared once the user responds and the tool resumes. */
  pending_approval_preview?: Record<string, unknown> | null;
  /** Human-readable name for this tool (e.g., 'Add Product' instead of 'add_product'). */
  readonly descriptive_name?: string | null;
  /** Whether this tool call should be displayed in the UI. */
  readonly show_in_ui?: boolean | null;
}

export interface ToolCallPartWriteAPI extends ResponsePartWriteAPI {
  /** Name of the tool being called */
  tool_name: string;
  /** Provider-issued identifier for this tool call. NOT globally unique — Gemini reuses short ids (call_NNNNN) across a long thread and across chats. Resolve via `resolve_by_call_id`, never a bare global filter. */
  tool_call_id: string;
  /** Arguments passed to the tool (an object; stored as JSON text) */
  args?: Record<string, unknown>;
  /** Whether this tool call is being streamed */
  is_streaming?: boolean;
  /** Set by tools that defer for approval after running a preview pass (e.g. delete tools' dry-run cascade). The frontend reads this to render the cascade scope alongside the Approve / Deny prompt. Cleared once the user responds and the tool resumes. */
  pending_approval_preview?: Record<string, unknown> | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ToolCallPartReadAPISchema: z.ZodType<ToolCallPartReadAPI> = ResponsePartReadAPISchemaObject.extend({
  tool_name: z.string(),
  tool_call_id: z.string(),
  args: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.unknown())).optional(),
  is_streaming: z.boolean().optional(),
  provider_name: z.string().nullable().optional(),
  provider_details: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.unknown()).nullable()).optional(),
  pending_approval_preview: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.unknown()).nullable()).optional(),
  descriptive_name: z.string().nullable().optional(),
  show_in_ui: z.boolean().nullable().optional(),
}).passthrough();

export const ToolCallPartWriteAPISchema: z.ZodType<ToolCallPartWriteAPI> = ResponsePartWriteAPISchemaObject.extend({
  tool_name: z.string(),
  tool_call_id: z.string(),
  args: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.unknown())).optional(),
  is_streaming: z.boolean().optional(),
  pending_approval_preview: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.record(z.string(), z.unknown()).nullable()).optional(),
}).passthrough();
